import { type ElementRef, forwardRef } from 'react';

import { Box, type BoxProps } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';

import roadBlock from './images/roadblock.svg';

const cardStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  margin: 'auto',
  textAlign: 'center',
});

type BoxElement = ElementRef<'div'>;

const Root = forwardRef<BoxElement, BoxProps>(({ children, css: cssProp, ...props }, forwardedRef) => {
  const className = css.raw(cardStyles, cssProp);

  return (
    <Box ref={forwardedRef} css={className} {...props}>
      {children}
    </Box>
  );
});

const Image = () => <img src={roadBlock} alt="Graphic of a bird in front of a road block" />;
const Header = Box;
const Description: React.FC<BoxProps> = ({ css: cssProp, ...props }) => (
  <Box css={{ marginTop: 'space.200', ...cssProp }} {...props} />
);

Image.displayName = 'ErrorContent.Image';
Header.displayName = 'ErrorContent.Header';
Description.displayName = 'ErrorContent.Description';

const ErrorContent = Object.assign(Root, { Image, Header, Description });
ErrorContent.displayName = 'ErrorContent';

export { ErrorContent };
